import inst from '@/backend/axios-instances'

const instance = inst.baseInstance
const resource = '/user'

export default {
  login(data) {
    return instance.post(`${resource}/login`, data);
  },
  logout() {
    return instance.post(`${resource}/logout`);
  },
  get(id) {
    return instance.get(`${resource}/${id}`);
  },
  changePassword(data) {
    return instance.put(`${resource}/changepassword`, data);
  },
  put(id, data) {
    return instance.put(`${resource}/${id}`, data);
  }
}
